/**
 * Risolve la lista di id filtro per una pagina dashboard.
 * Fonte unica: `reportConfiguration.filterSets[filterSetKey]` (JSON).
 *
 * `filterSets` nel JSON può essere:
 * - array di stringhe: `["registered_at", "area_name"]`
 * - oggetto: `{ "filterRefs": ["registered_at", ...] }`
 */
export const resolvePageFiltersConfig = (reportConfiguration, filterSetKey) => {
    if (!filterSetKey) return [];
    const raw = reportConfiguration?.filterSets?.[filterSetKey];
    const list = Array.isArray(raw) ? raw : raw?.filterRefs;
    return Array.isArray(list) ? list : [];
};
